import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=771eb57a&scoped=true"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&id=771eb57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771eb57a",
  null
  
)

export default component.exports